/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import * as React from 'react';
import {
  Avatar,
  AvatarGroup,
  Grid,
  Chip,
  Tooltip,
  Box,
  Button,
  CircularProgress,
  Typography,
  Icon,
} from '@mui/material';
import {
  CheckBox,
  CheckBoxOutlineBlank,
  AccountCircle,
  Schedule,
  Today,
  Visibility,
  DateRange,
  Delete,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment';

import AttachMoney from '@mui/icons-material/AttachMoney';
import {
  primary,
  blueGrey,
} from '../../../../../../utils/brandColors';

const getBackgroundColorForTask = (i, inPast) => {
  if (i.complete || (!i.scheduled && !i.task)) {
    return blueGrey[100];
  }
  return inPast
    ? 'white'
    : 'rgb(244, 244, 244)';
}
const getBackgroundImageForTask = (i) => {
  if (i.complete || (!i.scheduled && !i.task)) {
    return 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAEFJREFUKFNjZCAAzp492wBSwohPHUyRsbFxA06FyIpwmoiuCKtCbIowFOJShKIQnyK4QkKKwAqJUQRXCAonQgEPAL3PJvK6J0w6AAAAAElFTkSuQmCC)';
  }
  return 'none';
}

const getIconColorForTask = (i) => i.color

const AvatarGroupStyled = styled(AvatarGroup)({
  '& .MuiAvatarGroup-avatar': {
    width: 24,
    height: 24,
    fontSize: 14,
    border: 'none',
  },
});

const getDeleteIcon = (i) => {
  if (i.task && i.complete) {
    return (
      <CheckBox
        style={{ color: getIconColorForTask(i) }}
      />
    );
  }
  if (i.task && !i.complete) {
    return (
      <CheckBoxOutlineBlank
        style={{ color: getIconColorForTask(i) }}
      />
    );
  }
  if (i.scheduled) {
    return (
      <Schedule
        style={{ color: getIconColorForTask(i) }}
      />
    );
  }
  return (
    <Box
      sx={{
        marginright: '4px',
        padding: '12px',
      }}
    />
  );
}

export const getAvatarGroupForUsers = (assignments, id) => (
  <AvatarGroupStyled space={-2} _avatar={{ size: 'xs' }} max={2} total={assignments.length}>
    {(assignments.map((assignment) => (
      assignment.avatar
        ? (
          <Avatar
            sx={{
              width: 22,
              height: 22,
              border: 'none',
            }}
            src={assignment.avatar}
            key={`${id}}-${assignment.auth0UserId}`}
          />
        )
        : (
          <Avatar
            sx={{
              width: 22,
              height: 22,
              border: 'none',
            }}
            key={`${id}-${assignment.userFullName}`}
            alt={assignment.userFullName}
          >
            <AccountCircle />
          </Avatar>
        )
    ))
    )}
  </AvatarGroupStyled>
)

const getCalendarEventTooltip = (displayCalendarEvent, totalCalendarEvents) => {
  if (totalCalendarEvents === 0) {
    return 'No scheduled calendar events.'
  }
  const startString = `${totalCalendarEvents} calendar event${totalCalendarEvents === 1
    ? ''
    : 's'}`;

  return `${startString}${displayCalendarEvent
    ? `, ${totalCalendarEvents > 1
      ? 'first from'
      : ' from'} ${moment(displayCalendarEvent.event.start).format('h:mm a')}  to  ${moment(displayCalendarEvent.event.end).format('h:mm a')}`
    : ''}`
}

const customComparator = (prevProps, nextProps) => JSON.stringify(prevProps.items) === JSON.stringify(nextProps.items)
  && prevProps.showCalendarEvents === nextProps.showCalendarEvents && prevProps.overrideShowAll === nextProps.overrideShowAll

const TaskOverviewCell = React.memo(({
  items,
  onClick,
  onClickCalendarEvent,
  onTaskStateChange,
  showCalendarEvents,
  overrideShowAll,
  showTime,
  inPast,
}) => {
  const [showAll, setShowAll] = React.useState(false);
  const showExpanded = showAll || overrideShowAll;
  const [loadingTask, setLoadingTask] = React.useState(null);

  const tasks = items.sort((a, b) => a.complete - b.complete && a.sortDateTimestamp - b.sortDateTimestamp).filter((i) => !i.calendarEvent);
  const calendarEvents = items.sort((a, b) => a.sortDateTimestamp - b.sortDateTimestamp).filter((i) => i.calendarEvent);
  const displayCalendarEvent = calendarEvents.length > 0
    ? calendarEvents[0]
    : null;
  const totalCalendarEvents = calendarEvents.length;

  const onTaskUpdateDone = () => {
    setLoadingTask(null);
  }
  return (
    <Box>
      {
        showCalendarEvents && (
          <Box>
            <Tooltip
              title={getCalendarEventTooltip(displayCalendarEvent, totalCalendarEvents)}
              disableInteractive
            >
              <Chip
                sx={{
                  width: '100%',
                  justifyContent: 'space-between',
                  mb: 0.5,
                }}
                style={displayCalendarEvent
                  ? {
                    borderColor: primary[100],
                    borderLeft: `8px solid ${displayCalendarEvent.color}`,
                    color: 'inherit',
                    borderRadius: 0,
                    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                  }
                  : { display: 'none' }}
                variant="filled"
                onClick={(e) => {
                  e.stopPropagation();
                  onClickCalendarEvent(e, calendarEvents);
                }}
                onDelete={(e) => { e.stopPropagation(); onClickCalendarEvent(e, calendarEvents); }}
                deleteIcon={
                  displayCalendarEvent
                    ? (totalCalendarEvents > 1
                      ? <Visibility sx={{ color: `${blueGrey[500]} !important` }} />
                      : (displayCalendarEvent.participants && displayCalendarEvent.participants.length > 0
                        ? (getAvatarGroupForUsers(displayCalendarEvent.participants, displayCalendarEvent.id))
                        : (
                          <Box
                            sx={{
                              marginLeft: '4px',
                              padding: '12px',
                            }}
                          />
                        )))
                    : (
                      <Box
                        sx={{
                          marginLeft: '4px',
                          padding: '12px',
                        }}
                      />
                    )
                }
                label={displayCalendarEvent
                  ? (totalCalendarEvents > 1
                    ? `${totalCalendarEvents} Calendar Events`
                    : displayCalendarEvent.name)
                  : ''}
                icon={displayCalendarEvent
                  ? totalCalendarEvents > 1
                    ? <DateRange sx={{ color: `${displayCalendarEvent.color} !important` }} />
                    : <Today sx={{ color: `${displayCalendarEvent.color} !important` }} />
                  : (
                    <Box
                      sx={{
                        marginLeft: '4px',
                        padding: '12px',
                      }}
                    />
                  )}
              />
            </Tooltip>
          </Box>
        )
      }

      <Grid
        container
        sx={{
          mt: '6px',
          mb: '6px',
          pl: '6px',
          pr: '6px',
        }}
        alignItems="flex-start"
      >
        {tasks.slice(0, (showExpanded || tasks.length <= 3)
          ? tasks.length
          : 3).map((i, index) => (
            <Grid
              key={`${i.id}-${index}`}
              item
              xs={12}
            >
              {/* <Tooltip title={getTooltip(i)} disableInteractive> */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
                onClick={(e) => { e.stopPropagation(); onClick(e, i); }}
                style={{
                  borderTopLeftRadius: index === 0
                    ? 6
                    : 0,
                  borderTopRightRadius: index === 0
                    ? 6
                    : 0,
                  borderBottomLeftRadius: index === tasks.slice(0, (showExpanded || tasks.length <= 3)
                    ? tasks.length
                    : 3).length - 1
                    ? 6
                    : 0,
                  borderBottomRightRadius: index === tasks.slice(0, (showExpanded || tasks.length <= 3)
                    ? tasks.length
                    : 3).length - 1
                    ? 6
                    : 0,
                  border: '1px solid #CECECE',
                  borderLeft: `8px solid ${i.color}`,
                  borderBottom: index < tasks.slice(0, (showExpanded || tasks.length <= 3)
                    ? tasks.length
                    : 3).length - 1
                    ? 'none'
                    : '1px solid #CECECE',
                  backgroundColor: getBackgroundColorForTask(i, inPast),
                  backgroundImage: getBackgroundImageForTask(i),
                  color: 'inherit',
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      fontSize: '0.85rem',
                      ml: 0.5,
                      flex: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >{i.name}
                  </Typography>
                  {
                    (i.customStatus && !i.archived) && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Icon
                          sx={{
                            mr: 0.5,
                            fontSize: 12,
                            color: i.color,
                          }}
                        >{i.customStatus.icon}
                        </Icon>
                        <Typography
                          noWrap
                          sx={{
                            fontSize: 12,
                            lineHeight: '0.8125rem',
                          }}
                        >{i.customStatus.name}
                        </Typography>
                      </Box>
                    )
                  }
                  {
                    (i.archived) && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Delete
                          sx={{
                            mr: 0.25,
                            fontSize: 12,
                          }}
                        />
                        <Typography
                          noWrap
                          sx={{
                            fontSize: 12,
                            lineHeight: '0.8125rem',
                          }}
                        >Deleted
                        </Typography>
                      </Box>
                    )
                  }
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 0.5,
                  }}
                >
                  {
                    showTime && i.event && !i.event.allDay && <Typography variant="caption" sx={{ mr: 1 }}>{moment(i.event.start).format('h:mm a')}</Typography>
                  }
                  {i.billablePrice && <AttachMoney color="success" fontSize="small" />}
                  {
                    (
                      i.assignment && i.assignment.length > 0
                      && (getAvatarGroupForUsers(i.assignment, i.id))
                    )
                  }
                  {
                    (loadingTask && i.task && loadingTask.id === i.task.id)
                      ? <CircularProgress sx={{ animationDuration: '550ms' }} size={22} />
                      : (
                        <Box
                          onClick={(i.scheduled || !i.task)
                            ? (e) => { e.stopPropagation(); }
                            : (e) => { e.stopPropagation(); setShowAll(true); setLoadingTask(i.task); onTaskStateChange(i, onTaskUpdateDone); }}
                        >{getDeleteIcon(i)}
                        </Box>
                      )
                  }
                </Box>
              </Box>
              {/* </Tooltip> */}
            </Grid>
          ))}
        {
          (tasks.length > 3 && !overrideShowAll)
            ? (
              <Box
                sx={{
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <Button
                  size="small"
                  sx={{
                    marginTop: '4px',
                    fontWeight: 600,
                    fontSize: '12px',
                  }}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowAll(!showAll); }}
                >
                  {
                    !showAll
                      ? `+ ${tasks.length - 3} more`
                      : 'Hide expanded list'
                  }
                </Button>
              </Box>
            )
            : <Box />
        }
      </Grid>
    </Box>
  )
}, customComparator);

TaskOverviewCell.propTypes = {
  items: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  onTaskStateChange: PropTypes.func,
  onClickCalendarEvent: PropTypes.func,
  showCalendarEvents: PropTypes.bool,
  overrideShowAll: PropTypes.bool,
  inPast: PropTypes.bool,
  showTime: PropTypes.bool,
};

TaskOverviewCell.defaultProps = {
  onClick: () => { },
  onTaskStateChange: () => { },
  onClickCalendarEvent: () => { },
  showCalendarEvents: true,
  overrideShowAll: false,
  inPast: false,
  showTime: false,
};

export default TaskOverviewCell;
